import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiEndpoint } from "../../services/servicioCotizador/api.endpoint";
import { ContractRequest, QuotationPeopleRequest } from "../../models/cotizador/request/model.data.request";
import { campanias, ContratPeopleResponse, documentType, QuotationPeopleResponse } from '../../models/cotizador/response/model.data.response';
import { catchError, map, Observable, throwError } from "rxjs";


@Injectable({
    providedIn: 'root'
})

export class NetworkingContract {

    networkingOutput?: any;

    constructor(private httpClient: HttpClient, private apiEndpoint: ApiEndpoint) {

    }

    searchPeople(data: QuotationPeopleRequest): Observable<QuotationPeopleResponse> {
        data.codigoTipoPlan = "F";
        data.codigoLineaNegocio = "2";
    
        const url = this.apiEndpoint.URL_PEOPLE_COOMEVA();
    
        return this.httpClient.post<any>(`${url}consultarDatosUsuario`, data).pipe(
            map((response: any) => {
                let dat: any = response;
                let result: QuotationPeopleResponse = dat; // Ajusta según la estructura de tu respuesta
                return result;
            }),
            catchError((error: any) => {
                console.error("Error en searchPeople: ", error);
                let errorMessage = (error && error.message) ? error.message : "Ha ocurrido un error al buscar, contacte con el administrador";
                return throwError(errorMessage);
            })
        );
    }

    searchContract(data: ContractRequest): Observable<Array<ContratPeopleResponse>> {
        const url = this.apiEndpoint.URL_PEOPLE_COOMEVA();
        return this.httpClient.get<any>(`${url}consultarContratosActivos/${data.tipoDocumento}/${data.documento}`).pipe(
          map((response: any) => response as Array<ContratPeopleResponse>),
          catchError((error: HttpErrorResponse) => {
            console.log('mensaje ',error);            
            let errorMessage = 'Error desconocido'; // Mensaje predeterminado si no se puede obtener el mensaje de error    
            if (error.error instanceof ErrorEvent) {
              // Error del lado del cliente
              errorMessage = `Error: ${error.error.message}`;
            } else if (error.status === 400) {
              // Error BAD REQUEST
              errorMessage = error.error.message || "No se encontraron contratos activos";
            } else {
              // Otros errores
              errorMessage = `Error ${error.status}: ${error.message}`;
            }
            return throwError(errorMessage);
          })
        );
      }
      
    



}
